export const appointmentStatusMessage = {
  Approved: "Potwierdzona",
  Blocked: "Zablokowana",
  Canceled: "Anulowana",
  Pending: "Oczekująca na potwierdzenie",
};
